import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const locationsApi = createApi({
    reducerPath: 'locationsApi',
    tagTypes: ['locations', 'location'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getLocations: build.query({
            query: (data) => ({
                url: api.locations.getLocations(),
                method: 'GET',
                params: data
            }),
            providesTags: ['locations'],
            invalidatesTags: ['services']
        }),
        getLocationById: build.query({
            query: (id) => ({
                url: api.locations.getLocationById(id),
                method: 'GET',
            }),
            providesTags: ['locations', 'location'],
        }),
        createLocation: build.mutation({
            query: (data) => ({
                url: api.locations.createLocation(),
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['locations']
        }),
        editLocation: build.mutation({
            query: ({id, ...data}) => ({
                url: api.locations.editLocation(id),
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['locations']
        }),
        deleteLocation: build.mutation({
            query: ({id, ...data}) => ({
                url: api.locations.deleteLocation(id),
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: ['locations']
        }),
        toggleActive: build.mutation({
            query: ({id, ...data}) => ({
                url: api.locations.toggleActive(id),
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['locations']
        }),
    })
})

export const { useLazyGetLocationsQuery, useGetLocationByIdQuery, useCreateLocationMutation, useEditLocationMutation, useDeleteLocationMutation, useToggleActiveMutation } = locationsApi
